export default "__VITE_ASSET__DCbfWOyB__"